import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import SpeedIcon from '@mui/icons-material/Speed';
import BugReportIcon from '@mui/icons-material/BugReport';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import VisibilityIcon from '@mui/icons-material/Visibility';
import NoMeetingRoomIcon from '@mui/icons-material/NoMeetingRoom';
import SpeakerNotesOffIcon from '@mui/icons-material/SpeakerNotesOff';
import CommentsDisabledIcon from '@mui/icons-material/CommentsDisabled';
import PersonOffIcon from '@mui/icons-material/PersonOff';

// One icon per report `type` string (player_reports_AirWars3.type), shared by the admin Reports
// lookup and the player's own "me -> reports" lookup so both show the same visual language.
// Moved out of admin/reports.js (where this originally lived as a local function) when the new
// AirWars3 report/mod-action types (Not Cool, Sus, the three bans, Kick) needed the same
// treatment somewhere a player can see their own report history too, not just the admin view.
const ReportTypeIcon = ({ type }) => {
  switch (type) {
    case 'Speeding':
      return <Tooltip title="speeding"><SpeedIcon color="primary" style={{ marginLeft: '8px' }} /></Tooltip>;
    case 'SpeedHack':
      return <Tooltip title="speed hack"><BugReportIcon color="error" style={{ marginLeft: '8px' }} /></Tooltip>;
    case 'notcool':
      return <Tooltip title="not cool"><ThumbDownIcon color="warning" style={{ marginLeft: '8px' }} /></Tooltip>;
    case 'sus':
      return <Tooltip title="sus"><VisibilityIcon color="action" style={{ marginLeft: '8px' }} /></Tooltip>;
    case 'banRoomEntry':
      return <Tooltip title="room ban"><NoMeetingRoomIcon color="error" style={{ marginLeft: '8px' }} /></Tooltip>;
    case 'banChatGame':
      return <Tooltip title="game chat ban"><SpeakerNotesOffIcon color="error" style={{ marginLeft: '8px' }} /></Tooltip>;
    case 'banChatLobby':
      return <Tooltip title="lobby chat ban"><CommentsDisabledIcon color="error" style={{ marginLeft: '8px' }} /></Tooltip>;
    case 'kick':
      return <Tooltip title="kick"><PersonOffIcon color="error" style={{ marginLeft: '8px' }} /></Tooltip>;
    case 'cheating':
      return <></>;
    default:
      return <Tooltip title="cheating"><VerifiedUserIcon color="disabled" style={{ marginLeft: '8px' }} /></Tooltip>;
  }
};

export default ReportTypeIcon;
